export default __webpack_public_path__ + "static/deep-dive-desktop-11b584ed305f2185a9e91c10ccdbd352.webp";